module.exports = __webpack_public_path__ + "static/media/pier-beam-foundation@2x.7e67b6a8.jpg";